import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SelectPolyIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M9.65429 20.624C9.39799 19.2818 8.48989 17.9726 7.20779 17.0527C7.00059 15.4987 5.68059 14.292 4.07079 14.292C2.31789 14.292 0.89209 15.7178 0.89209 17.4707C0.89209 19.2236 2.31789 20.6504 4.07079 20.6504C5.35059 20.6504 6.44959 19.8857 6.95309 18.7929C7.59179 19.4156 8.03809 20.1575 8.18109 20.9062C8.26559 21.3476 8.27969 21.9921 7.86959 22.5615C7.62739 22.8974 7.70309 23.3662 8.03899 23.6084C8.37139 23.8489 8.84279 23.7767 9.08639 23.4385C9.65819 22.6455 9.85499 21.6729 9.65429 20.624ZM4.07079 19.1504C3.14499 19.1504 2.39209 18.3965 2.39209 17.4707C2.39209 16.5449 3.14499 15.792 4.07079 15.792C4.99659 15.792 5.74999 16.5449 5.74999 17.4707C5.74999 18.3965 4.99659 19.1504 4.07079 19.1504Z"
        fill={color}
      />
      <path
        d="M22.8014 3.17415L22.7551 3.16685C22.3585 3.10415 22.0879 2.73155 22.151 2.33505C21.7986 2.52715 21.3566 2.39745 21.1646 2.04505L21.1422 2.00395C20.9502 1.65155 21.0802 1.21025 21.4326 1.01825L22.325 0.532052C23.0535 0.135152 23.9206 0.746852 23.7912 1.56625L23.6326 2.56995C23.57 2.96635 23.1978 3.23685 22.8014 3.17415Z"
        fill={color}
      />
      <path
        d="M13.3996 5.48901L11.8573 6.33051L11.2508 6.16531C10.8511 6.05641 10.4389 6.29211 10.33 6.69181C10.221 7.09151 10.4567 7.50381 10.8564 7.61281L11.6573 7.83111C11.9066 7.89911 12.1725 7.86791 12.3993 7.74411L14.1183 6.80611C14.482 6.60761 14.6159 6.15191 14.4174 5.78831C14.219 5.42461 13.7632 5.29061 13.3996 5.48901Z"
        fill={color}
      />
      <path
        d="M2.55888 3.59744L1.51498 3.31244C0.785777 3.11334 0.107877 3.76404 0.276877 4.50074L0.854377 7.01775C0.946977 7.42135 1.34928 7.67354 1.75288 7.58095C2.15658 7.48825 2.40928 7.08584 2.31668 6.68224L1.92598 4.97934L2.16388 5.04424C2.56338 5.15334 2.97568 4.91784 3.08478 4.51834C3.19388 4.11884 2.95838 3.70654 2.55888 3.59744Z"
        fill={color}
      />
      <path
        d="M20.5055 11.9866L20.0002 15.194C19.9357 15.6031 20.2151 15.9869 20.6241 16.0514L20.6243 16.0514C21.0334 16.1159 21.4173 15.8365 21.4817 15.4274L21.987 12.22C22.0515 11.8109 21.7721 11.4271 21.363 11.3626L21.3629 11.3626C20.9538 11.2982 20.5699 11.5775 20.5055 11.9866Z"
        fill={color}
      />
      <path
        d="M21.5188 5.57188L21.0124 8.77915C20.9479 9.18819 21.2271 9.57213 21.6361 9.63671L21.6364 9.63675C22.0455 9.70133 22.4294 9.4221 22.494 9.01306L23.0004 5.80579C23.0649 5.39675 22.7857 5.01281 22.3767 4.94823L22.3764 4.94819C21.9673 4.88361 21.5834 5.16284 21.5188 5.57188Z"
        fill={color}
      />
      <path
        d="M4.60954 4.98413L4.60941 4.98462C4.50048 5.38413 4.73604 5.79631 5.13556 5.90525L8.02084 6.69193C8.42036 6.80086 8.83254 6.5653 8.94147 6.16578L8.9416 6.16529C9.05053 5.76577 8.81496 5.35359 8.41544 5.24466L5.53017 4.45798C5.13065 4.34905 4.71847 4.58461 4.60954 4.98413Z"
        fill={color}
      />
      <path
        d="M18.6985 2.49142L16.0734 3.9236C15.7099 4.12194 15.576 4.57741 15.7743 4.94092L15.7747 4.94154C15.973 5.30506 16.4285 5.43897 16.792 5.24064L19.417 3.80845C19.7805 3.61012 19.9144 3.15465 19.7161 2.79113L19.7158 2.79052C19.5174 2.427 19.062 2.29309 18.6985 2.49142Z"
        fill={color}
      />
      <path
        d="M2.16167 9.05481L2.16098 9.05497C1.75737 9.14758 1.50525 9.54985 1.59787 9.95346L2.26889 12.8779C2.36151 13.2815 2.76378 13.5336 3.16739 13.441L3.16808 13.4408C3.57169 13.3482 3.82381 12.9459 3.73119 12.5423L3.06016 9.61793C2.96755 9.21431 2.56528 8.9622 2.16167 9.05481Z"
        fill={color}
      />
      <path
        d="M10.259 18.4682L10.259 18.4683C10.1947 18.8774 10.4741 19.2611 10.8832 19.3255L13.8474 19.7917C14.2564 19.8561 14.6402 19.5766 14.7046 19.1675L14.7046 19.1674C14.7689 18.7584 14.4895 18.3746 14.0804 18.3102L11.1162 17.844C10.7072 17.7797 10.3234 18.0591 10.259 18.4682Z"
        fill={color}
      />
      <path
        d="M19.4933 18.4L19.3758 19.143L17.1528 18.7933C16.7437 18.729 16.3599 19.0084 16.2955 19.4174C16.231 19.8265 16.5105 20.2105 16.9196 20.2749L19.8836 20.7418C20.2926 20.8062 20.6764 20.527 20.7411 20.1181L20.9757 18.6344C21.0404 18.2253 20.7612 17.8412 20.3521 17.7766C19.943 17.7118 19.558 17.9909 19.4933 18.4Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectPolyIcon.displayName = 'SelectPolyIcon';
